import { useTranslation } from "react-i18next";
import { selectUser } from "@/store/slices/user.slice";
import { useGetSidebarPersmissionsQuery } from "@/services/(my-space)/userApi";
import { NOTIFICATIONS_PLATFORM_FILTER_ENUM } from "@/utils/enums/notifications.enum";
import clsx from "clsx";
import { useSelector } from "react-redux";

/** `value` is the enum contract; `label` is a lookup key resolved at render. */
const NOTIFICATION_TABS = [
  {
    label: "common:spaces.my_space",
    value: NOTIFICATIONS_PLATFORM_FILTER_ENUM.MY_SPACE,
  },
  {
    label: "common:spaces.company",
    value: NOTIFICATIONS_PLATFORM_FILTER_ENUM.COMPANY,
  },
];

interface IProps {
  activeTab: string;
  setActiveTab: (value: string) => void;
}

export const NotificationsTabs = ({ activeTab, setActiveTab }: IProps) => {
  const { t } = useTranslation(["common", "nav"]);
  const { user } = useSelector(selectUser);
  const { data: sidebarLinks } = useGetSidebarPersmissionsQuery();
  // Mirrors RequireCompanyAccessMiddleware's gate exactly, so this pill is
  // visible if and only if the user can actually reach /company/notifications.
  const hasCompanyAccess =
    (user?.isCompanySuperAdmin ?? false) ||
    (sidebarLinks?.data?.company?.length ?? 0) > 0;

  const visibleTabs = NOTIFICATION_TABS.filter((tab) => {
    if (tab.value === NOTIFICATIONS_PLATFORM_FILTER_ENUM.COMPANY)
      return hasCompanyAccess;
    return true;
  });

  return (
    <div className="flex gap-1 px-3 py-2 border-b overflow-x-auto scrollbar-hidden">
      {visibleTabs.map((tab) => {
        const isActive = activeTab === tab.value;

        return (
          <button
            key={tab.value}
            onClick={() => setActiveTab(tab.value)}
            className={clsx(
              "shrink-0 flex items-center gap-1 rounded-md px-2.5 py-1 text-[11px] font-medium transition-all duration-150",
              isActive
                ? "bg-primary/15 text-primary"
                : "text-muted-foreground hover:bg-muted hover:text-foreground",
            )}
          >
            {t(tab.label)}
          </button>
        );
      })}
    </div>
  );
};
